module.exports = __webpack_public_path__ + "assets/img/like_full.11e3cfe8.png";